import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _omitBy from "lodash/omitBy";
import _get from "lodash/get";
import _clone from "lodash/clone";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Tracking as NWTracking } from '@nerdwallet/nw-client-lib';
export default (function (eventName) {
  var trackingState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var flow = arguments.length > 3 ? arguments[3] : undefined;

  var trk = _clone(_get(trackingState, 'trk', {}));

  if (flow) trk.trk_flow = flow;

  var amplitudeOnlyTrk = _get(trackingState, 'amplitudeOnlyTrk', {});

  var appName = trackingState.appName;

  var eventData = _omitBy(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    formName: eventName,
    appName: appName,
    fieldName: eventName
  }, data), amplitudeOnlyTrk), trk), {}, {
    // additional data should contain all additional data we send to amplitude minus trk params
    additionalData: JSON.stringify(_objectSpread(_objectSpread({}, data), trk))
  }), function (val) {
    return !val;
  });

  NWTracking.formInputChanged(eventData);
});